export enum SettingTypeEnum {
    BARRING_ALL_PREMIUM_CALL_SMS = 'BARRING_ALL_PREMIUM_CALL_SMS',
    BARRING_SMS_PREMIUM_INFO = 'BARRING_SMS_PREMIUM_INFO',
    BARRING_SMS_PREMIUM_GAME = 'BARRING_SMS_PREMIUM_GAME',
    BARRING_SMS_PREMIUM_PAYM = 'BARRING_SMS_PREMIUM_PAYM',
    BARRING_SMS_PREMIUM_EROS = 'BARRING_SMS_PREMIUM_EROS',
    ROAMING_TYPE = 'ROAMING_TYPE',
    BARRING_INTL_TRAFIC = 'BARRING_INTL_TRAFIC',
}